// extracted by mini-css-extract-plugin
export default {"link":"YellowLink_link__zZpuh","paint":"YellowLink_paint__qc0Be","paintBlue":"YellowLink_paintBlue__zyQVI","text":"YellowLink_text__VyHet"};